import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import { apiURLMapping } from 'Pages/ChanceGames/cgUtils';
import {
  GET_CHANCE_GAMES_ACTIVE_DRAW_REQUEST,
  GET_CHANCE_GAMES_ACTIVE_DRAW_SUCCESS,
  GET_CHANCE_GAMES_ACTIVE_DRAW_FAILURE,
  GET_CHANCE_GAMES_DRAW_LIST_REQUEST,
  GET_CHANCE_GAMES_DRAW_LIST_SUCCESS,
  GET_CHANCE_GAMES_DRAW_LIST_FAILURE,
  GET_CHANCE_GAMES_DRAW_PRIZE_REQUEST,
  GET_CHANCE_GAMES_DRAW_PRIZE_SUCCESS,
  GET_CHANCE_GAMES_DRAW_PRIZE_FAILURE,
  GET_DRAWS_REQUEST,
  GET_DRAWS_SUCCESS,
  GET_DRAWS_FAILURE,
  GET_DRAWS_BY_ID_REQUEST,
  GET_DRAWS_BY_ID_SUCCESS,
  GET_DRAWS_BY_ID_FAILURE,
  RAFFLE_BUY_TICKET_REQUEST,
  RAFFLE_BUY_TICKET_SUCCESS,
  RAFFLE_BUY_TICKET_FAILURE,
  GET_TICKET_COUNT_REQUEST,
  GET_TICKET_COUNT_SUCCESS,
  GET_TICKET_COUNT_FAILURE,
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;
import { openModal } from 'Store/actions';

export const getCGActiveDraw = gameType => async dispatch => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_ACTIVE_DRAW_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/draws/latest?gameType=${apiURLMapping[gameType]}`);

    dispatch({
      type: GET_CHANCE_GAMES_ACTIVE_DRAW_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_CHANCE_GAMES_ACTIVE_DRAW_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getCGDrawList = (gameType, status) => async dispatch => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_DRAW_LIST_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/draws?gameType=${apiURLMapping[gameType]}&drawStatus=${status}`);

    dispatch({
      type: GET_CHANCE_GAMES_DRAW_LIST_SUCCESS,
      payload: res.data.draws
    });

    dispatch(getCDDrawPrizeDetails(res.data.draws[0].drawId));

  } catch (e) {
    dispatch({
      type: GET_CHANCE_GAMES_DRAW_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getCDDrawPrizeDetails = drawId => async dispatch => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_DRAW_PRIZE_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/prize-info?drawId=${drawId}`);

    dispatch({
      type: GET_CHANCE_GAMES_DRAW_PRIZE_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_CHANCE_GAMES_DRAW_PRIZE_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getDraws = (drawStatus, gameType) => async dispatch => {
  try {
    dispatch({
      type: GET_DRAWS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/draws?drawStatus=${drawStatus}&gameType=${gameType}`);

    dispatch({
      type: GET_DRAWS_SUCCESS,
      payload: res.data
    });

    return res?.data;

  } catch (e) {
    if (e.response.status !== 200) {
      dispatch(openModal('raffleErrorModal', { turnBackSantra: true, forceBackOnClose: true }));
    }
    dispatch({
      type: GET_DRAWS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getDrawById = drawId => async dispatch => {
  try {
    dispatch({
      type: GET_DRAWS_BY_ID_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/draws/${drawId}`);

    dispatch({
      type: GET_DRAWS_BY_ID_SUCCESS,
      payload: res.data
    });


    return res?.data;

  } catch (e) {
    if (e.response.status !== 200) {
      dispatch(openModal('raffleErrorModal', { turnBackSantra: true, forceBackOnClose: true }));
    }
    dispatch({
      type: GET_DRAWS_BY_ID_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const raffleBuyTicket = requestBody => async (dispatch, getState) => {
  try {
    const isAuthenticated = getState().auth.isAuthenticated;

    if (!isAuthenticated) {
      History.push('/giris-yap');
      return;
    }

    dispatch({
      type: RAFFLE_BUY_TICKET_REQUEST
    });
  
    const res = await axios.post(`${API_GATEWAY}/mobile/digital-lottery/coupons/play`, requestBody);

    dispatch({
      type: RAFFLE_BUY_TICKET_SUCCESS,
      payload: res.data
    });

    return res?.data;

  } catch (e) {
    dispatch({
      type: RAFFLE_BUY_TICKET_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getTicketCount = requestBody => async (dispatch, getState) => {
  try {

    dispatch({
      type: GET_TICKET_COUNT_REQUEST
    });
  
    const res = await axios.post(`${API_GATEWAY}/mobile/digital-lottery/coupons/count`, requestBody);
    
    dispatch({
      type: GET_TICKET_COUNT_SUCCESS,
      payload: res.data
    });
    return res?.data;

  } catch (e) {
    dispatch({
      type: GET_TICKET_COUNT_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};
